module.exports = __webpack_public_path__ + "static/media/verticalIcon.883b0ce8.svg";